/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { ListItem, ListItemText, ListItemIcon, Dialog, DialogContent, DialogActions, Button, Typography, Grid, Link } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { ToolItemAppBar } from './ToolItemAppBar';
import { License } from './License';
import { FeedbackForm } from './FeedbackForm';
import * as ShortcutManager from '../model/ShortcutManager';

export const AboutScreenToolItem = () => {
    const [open, setOpen] = React.useState(false);
    
    const handleOpen = () => {
        ShortcutManager.freezeShortcuts(true);
        setOpen(true);
    }

    const handleClose = () => {
        ShortcutManager.freezeShortcuts(false);
        setOpen(false);
    }

    return (
        <React.Fragment>
            <ListItem button onClick={handleOpen}>
                <ListItemIcon>
                    <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"About Duelmaster"} />
            </ListItem>
            <Dialog fullScreen open={open} onClose={handleClose}>
                <ToolItemAppBar handleClose={handleClose} title={"About Duelmaster"} />
                <DialogContent>
                    <Grid container>
                        <Grid item sm={6} xs={12}>
                            <Typography variant="h6">Duelmaster Version 0.3 beta</Typography>
                            <Typography>
                                Created by Lauren Gyldenlove<br />
                                Like this software? <Link color="primary" href="https://ko-fi.com/gyldenlove/" target="_blank" rel="noreferrer">Buy me a coffee! :)</Link>
                            </Typography>
                            <License />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <FeedbackForm />
                        </Grid>
                        <Grid item xs={12}>
                        <Typography>External Credits</Typography>
                            <ul>
                                <li>Eye of Horus graphic by Eff Dahl licensed under <a href="https://creativecommons.org/licenses/by-sa/4.0/">Creative Commons 4.0</a>.</li>
                                <li>Ankh graphic by Inowen licensed under <a href="https://creativecommons.org/licenses/by-sa/4.0/">Creative Commons 4.0</a></li>
                            </ul>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color={"primary"} onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}